import React from "react";

import {
  makeStyles,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

const useSearchStyles = makeStyles((theme) => ({
  textField: {
    width: "50%"
  }
}));

export const Searchbar = ({ searchTerm, onSearch, onClear, table }) => {
  let labelWidth;
  if (table === "Placements") {
    labelWidth = 140;
  } else {
    labelWidth = 120;
  }

  const classes = useSearchStyles();

  const handleClear = () => {
    onClear();
  };

  return (
    <FormControl className={classes.textField} variant="outlined">
      <InputLabel htmlFor="outlined-adornment-search">
        Search {table}
      </InputLabel>
      <OutlinedInput
        className={classes.input}
        id="outlined-adornment-search"
        type="text"
        value={searchTerm}
        onChange={onSearch}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="clear search"
              onClick={handleClear}
              edge="end"
            >
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        }
        labelWidth={labelWidth}
      />
    </FormControl>
  );
};

Searchbar.defaultProps = {
  searchTerm: "",
  onSearch: () => {}
};
